import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { _nextTrackEvent } from '../index';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

export const EVENT_IDS = {
  VIEW_IMPRECISE_LOCATION_ALERT: '7944',
  VIEW_MAP_PIN_ADJUSTMENT_MODAL: '7945',
  CLICK_CORRECT_MAP_PIN: '7946',
  CLICK_REPORT_MAP_PIN: '7947',
  CLICK_SUBMIT_MAP_PIN: '7948',
} as const;

// https://dataportal.zillowgroup.net/event-registry/7944
export const emitViewImpreciseLocationAlertEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  _nextTrackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.VIEW_IMPRECISE_LOCATION_ALERT,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_address_confirmation_modal',
      trigger_type_nm: 'view',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'zrm_address_confirmation_modal',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/7945
export const emitViewMapPinAdjustmentModalFromPostingPathEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  _nextTrackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.VIEW_MAP_PIN_ADJUSTMENT_MODAL,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'view_zrm_fix_property_location_alert',
      trigger_type_nm: 'view',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'view_zrm_fix_property_location_alert',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/7946
export const emitClickCorrectMapPinLocationFromPostingPathEvent = ({
  user,
  currentProperty,
}: {
  user: ZrmClickstreamUser;
  currentProperty: ZrmClickstreamListing;
}) =>
  _nextTrackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CLICK_CORRECT_MAP_PIN,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'posting_path',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'correct_map_pin_location',
      trigger_source_nm: 'zrm_correct_map_pin_alert',
    },
    semantic: {
      semantic_event_nm: 'correct_map_pin_location',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(currentProperty),
  });

// https://dataportal.zillowgroup.net/event-registry/7947
export const emitClickReportMapPinLocationFromPropertyDashboardEvent = ({
  user,
  currentProperty,
}: {
  user: ZrmClickstreamUser;
  currentProperty: ZrmClickstreamListing;
}) =>
  _nextTrackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CLICK_REPORT_MAP_PIN,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_property_overview',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'zrm_single_property_dashboard_overflow_menu',
      trigger_source_nm: 'report_map_pin_location',
    },
    semantic: {
      semantic_event_nm: 'correct_map_pin_location',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(currentProperty),
  });

// https://dataportal.zillowgroup.net/event-registry/7948
export const emitClickSubmitMapPinAdjustmentRequestEvent = ({
  user,
  currentProperty,
  triggerLocation,
}: {
  user: ZrmClickstreamUser;
  currentProperty: ZrmClickstreamListing;
  triggerLocation: 'posting_path' | 'zrm_property_overview';
}) =>
  _nextTrackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CLICK_SUBMIT_MAP_PIN,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'submit_ticket',
      trigger_source_nm: 'zrm_submit_location_adjustment_modal',
    },
    semantic: {
      semantic_event_nm: 'submit_map_pin_ticket_zrm',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(currentProperty),
  });
